import React from "react";
import { PieChart } from "../../../../../../shared";
import "./enrollmentEmployeeCard.css";
import { BenifitSummaryEnrollmentEmployeeCard } from "../../../../../../../@types/components/enrollmentCardGrid.types";

const EnrollmentEmployeeCard: React.FC<BenifitSummaryEnrollmentEmployeeCard> = ({
	cardUIProps,
	chartProps
}): JSX.Element => {
	const { cardTitle, cardColor, overallTotal, marginTopText, maleCount, femaleCount } = cardUIProps;
	const { data, options } = chartProps;

	return (
		<div className="enrollment-employee-card" style={{ backgroundColor: `${cardColor}` }}>
			<div className="element-section-title">{cardTitle}</div>
			<div className="element-section-value" style={marginTopText ? { marginTop: `${marginTopText}` } : {}}>
				{overallTotal}
			</div>

			<div className="element-section-chart">
				<div className="chart-info">
					<div className="chart-info-male">
						<div className="male-label">
							<div className="male-label-description">Male Employee Count</div>
						</div>
						<div className="male-value">{maleCount}</div>
					</div>
					<div className="chart-info-female">
						<div className="female-label">
							<div className="male-label-description">Female Employee Count</div>
						</div>
						<div className="female-value">{femaleCount}</div>
					</div>
				</div>
				<div className="chart-diagram">
					{chartProps ? <PieChart data={data as any} options={options} /> : <></>}
				</div>
			</div>
		</div>
	);
};

export default EnrollmentEmployeeCard;
